<div class="auth-container" [ngClass]="{ mobile: isMobile$ | async }">
  <mat-card class="auth-card">
    <h1 class="mat-headline-3">{{ 'WM_TECH.AUTH.AFTER_SIGNUP.TITLE' | translate }}</h1>
    <h2 class="mat-subtitle-2">
      {{ 'WM_TECH.AUTH.AFTER_SIGNUP.SUBTITLE' | translate }}
    </h2>

    <mat-card-content>
      <p class="confirmation-text">
        {{ 'WM_TECH.AUTH.AFTER_SIGNUP.COMPLETE' | translate }}
      </p>

      <div class="auth-links">
        <p class="activation-text">{{ 'WM_TECH.AUTH.ACTIVATE.RESEND' | translate }}</p>

        <button mat-raised-button color="tech-button-bg-primary" class="submit-button mt-2" (click)="resendConfirmation()">
          {{ 'WM_TECH.AUTH.ACTIVATE.RESEND_BUTTON' | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
